import PropTypes from "prop-types";
import styles from "./CustomSteps.module.css";

const CustomSteps = ({steps, current}) => {
  return (
    <div className={styles.stepsRow}>
      {steps.map((step, idx) => {
        const isActive = idx === current;
        const isCompleted = idx < current;
        const stepClass = `${styles.step} ${isActive ? styles.active : ""} ${isCompleted ? styles.completed : ""} ${idx > current ? styles.inactive : ""}`;

        return (
          <div
            key={step.title}
            style={{display: "flex", alignItems: "center"}}
          >
            {idx > 0 && <div className={`${styles.connector} ${idx <= current ? styles.done : ""}`} />}
            <div className={stepClass}>
              <span className={styles.stepNumber}>{idx + 1}</span>
              <span className={styles.stepTitle}>{step.title}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

CustomSteps.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  current: PropTypes.number.isRequired,
};

export default CustomSteps;
